/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import _, { update } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { TranslatorContext, useTranslator } from '@jutro/locale';

import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import metadata from './CommercialPolicySummary.metadata.json5';
import CommercialPolicyDetailsAccordion from '../CommercialPolicyDetailsAccordion/CommercialPolicyDetailsAccordion.jsx';
import messages from './CommercialPolicySummary.messages.js'
import styles from './CommercialPolicySummary.module.scss'

const CommercialPolicySummary = props => {
    const {
        policyDetailsData,
        lobData_TWIA,
        policyTransactionDetails,
        producerOfServiceValue,
        producerOfRecordValue,
    } = props;

    const translator = useTranslator();
    const isDwelling = _.get(lobData_TWIA, 'homeOwners.dwellingDTO.policyType') === 'Dwelling and Personal Property';
    const isTenant = _.get(lobData_TWIA, 'homeOwners.dwellingDTO.policyType') === 'Tenant Personal Property Only';
    const isMH = _.get(lobData_TWIA, 'homeOwners.dwellingDTO.policyType') === 'Manufactured Home';
    const isApartmentOrCondo = _.get(lobData_TWIA, 'homeOwners.dwellingDTO.policyType') === 'Condo Unit Owner'
        || (_.get(lobData_TWIA, 'homeOwners.dwellingDTO.policyType')) === 'Tenant Personal Property Only'
        && (_.get(lobData_TWIA, 'homeOwners.dwellingDTO.homeDetails.structureType_TWIA') === 'AptBuilding');



    const createRoofAndRepairs_TWIA = useCallback(() => {
        const MH = isMH ? '-MH' : '';

        const items = [];
        const roofUpdate = _.get(lobData_TWIA, 'homeOwners.dwellingDTO.constructionDetails.roofUpdateDtls_TWIA');
        const roofAdditionns = _.get(lobData_TWIA, 'homeOwners.dwellingDTO.constructionDetails.repairAdditionsDTO_TWIA');

        if (!_.isUndefined(roofUpdate)) {
            _.get(lobData_TWIA, 'homeOwners.dwellingDTO.constructionDetails.roofUpdateDtls_TWIA').forEach((entry) => {
                items.push({
                    // DE11212 - Manufactured Home type label
                    'type': isMH ? translator(messages.addedLivingSpace) : translator(messages.roofUpdate),
                    'date': new Date(entry.roofUpdateDate.year, entry.roofUpdateDate.month, entry.roofUpdateDate.day).toDateString(),
                    'cert': entry.hasWPI8CertOfCompIssued_TWIA ? 'Yes' : 'No',
                    'desc': entry.roofUpdateType,
                });
            });
        }

        if (!_.isUndefined(roofAdditionns)) {
            _.get(lobData_TWIA, 'homeOwners.dwellingDTO.constructionDetails.repairAdditionsDTO_TWIA').forEach((entry) => {
                items.push({
                    // DE11212 - Manufactured Home type label
                    'type': isMH ? translator(messages.addedLivingSpaceRepairsAddition) : translator(messages.repairsAdditions),
                    'date': new Date(entry.repairDate.year, entry.repairDate.month, entry.repairDate.day).toDateString(),
                    'cert': entry.hasWPI8CertOfCompIssued_TWIA ? 'Yes' : 'No',
                    'desc': entry.repairDesc
                });
            });
        }


        return items.sort((a, b) => {
            return a.date - b.date;
        });
    }, [isMH, lobData_TWIA, translator])

    const roofAndRepairs = createRoofAndRepairs_TWIA();

    const overrideProps = {
        commercialPolicyDetailsAcc: {
            policyDetailsData,
            policyTransactionDetails,
            producerOfServiceValue,
            producerOfRecordValue,
            isDwelling,
            isTenant,
            isMH,
            isApartmentOrCondo
        }
    };



    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {

        },
        resolveComponentMap: {
            CommercialPolicyDetailsAccordion,
        }
    };




    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
};

CommercialPolicySummary.propTypes = wizardProps;
CommercialPolicySummary.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    authHeader: PropTypes.shape({}).isRequired,
};
export default withAuthenticationContext(withRouter(CommercialPolicySummary));
